
<div class="display-block full-width"  fixedScroll [otherElements]="append(footer)" [baseElement]="baseElement" >
  <div 
    class="gap-standard padding-standard flex--align-start"
    [screenSizeClasses]="{
      sm:['flex-column'],
      xs:['flex-column'],
      md:['grid-columns-2'],
      lg:['grid-columns-3'],
      xl:['grid-columns-4']
    }"
    
  >    

    <div
      *ngFor="let splugDefinition of splugDefinitionsWithActionParamsObs | async;let idx=index"
      [ngClass]="{'full-width':isSmallerScreenObs | async}" 
    >

      <mat-card   appearance="outlined" 
                  [ngClass]="{
                    'selected-card':(selectedSplugsSubject | async)[splugDefinition.id],
                    'error-card':(errorSplugObs | async)[splugDefinition.id],
                    'valid-card':(validSplugsObs | async)[splugDefinition.id]
                  }"
                  class="position-relative padding-none"
        
      >
  
        <mat-card-header class="padding-standard "
                        [ngClass]="{
                          'primary-background-A200-transparent':(selectedSplugsSubject | async)[splugDefinition.id],
                          'border-gray-bottom':!(selectedSplugsSubject | async)[splugDefinition.id],
                          'border-primary-bottom':(selectedSplugsSubject | async)[splugDefinition.id]
                        }"
        >
          <mat-checkbox color="primary" 
                        class="full-width"
                        [checked]="(selectedSplugsSubject | async)[splugDefinition.id]"
                        (change)="toggleSelectedSplug($event,splugDefinition.id)" 
                        (click)="$event.stopPropagation()"
                      
          >
            <span 
              class="mat-headline-6" 
              [ngClass]="{'primary-text':(selectedSplugsSubject | async)[splugDefinition.id]}"
            >
              {{ splugDefinition.title  }}
            </span>

          </mat-checkbox>  
        </mat-card-header>
        <mat-card-content   class="gap-small padding-standard">
          <ss-user-splug-form [splugDefinition]="splugDefinition"></ss-user-splug-form>
        </mat-card-content>
        
        <mat-icon *ngIf="(errorSplugObs | async)[splugDefinition.id]" 
                  color="warn" 

                  [ngClass]="{
                       'float-icon-small':!(isLargeScreenObs | async),
                       'float-icon':isLargeScreenObs | async
                  }"
                  
        >
          error
        </mat-icon>

        <mat-icon   *ngIf="(validSplugsObs | async)[splugDefinition.id]" 
                    color="accent" 
                    [ngClass]="{
                        'float-icon-small':!(isLargeScreenObs | async),
                        'float-icon':isLargeScreenObs | async
                    }"
        >
          check_circle
        </mat-icon>
      </mat-card>
    </div>

    <ss-core-loader-outlet height="100%" [keys]="['user-splug.save','user-splug.validate','splugs.get']"></ss-core-loader-outlet>

  </div>
</div>

<div #footer class="responsive-actions flex--align-center flex--justify-between border-primary-top padding-standard">
  <ng-container *ngIf="isSmallerScreenObs | async;else standardMode">
    <button (click)="reset()" mat-raised-button color="warn">
      <mat-icon>refresh</mat-icon>{{'ss-general.reset' | translate}}
    </button>
    <button libLoaderButton [keys]="['user-splug.save']" (click)="save()" mat-raised-button color="accent">
      <mat-icon>save</mat-icon>{{'ss-general.save' | translate}}
    </button>

    <button libLoaderButton [keys]="['user-splug.validate']" (click)="validate()" mat-raised-button color="primary">
      <mat-icon>check</mat-icon>{{'ss-general.validate' | translate}}
    </button>
  </ng-container>
  <ng-template #standardMode>
    <button (click)="reset()" mat-raised-button color="warn">
      <mat-icon>refresh</mat-icon>{{'ss-general.reset' | translate}}
    </button>
    
    <div class="flex-row flex--align-center ">
      <button libLoaderButton [keys]="['user-splug.save']" (click)="save()" mat-raised-button color="accent">
        <mat-icon>save</mat-icon>{{'ss-general.save' | translate}}
      </button>
  
      <button libLoaderButton [keys]="['user-splug.validate']" (click)="validate()" mat-raised-button color="primary">
        <mat-icon>check</mat-icon>{{'ss-general.validate' | translate}}
      </button>
    </div>
  </ng-template>
  
  
  
</div>
  
    

  